module.exports = __webpack_public_path__ + "img/character.54af67a2.png";